import {
	Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy,
	ChangeDetectorRef
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { NavigationService, NetFacadeService } from 'netview';
import { IdentityService } from 'identity';
import { DiscResultsService } from 'discovery';
import { MenuItem } from 'primeng/api';
import { UpdateResultDto, AgentMonitorPolicyDto } from 'UvExplorerServer.Dtos.TS';
import { GetAgentMonitorPoliciesResultDto } from 'UvExplorerServer.Dtos.TS';
import { MonitorType, IpAddress, MacAddress, SnmpOid } from 'DiscoveryEngine.TS/Core';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { DisplayDeviceListEntryDto, DisplayDeviceListDto } from 'UvExplorerServer.Dtos.TS/Session';


export class MonitorPolicyListEntry {
	public monitorPolicyGuid: string;
	public name: string;
	public agent: string;
	public enabled: boolean;
	public state: string;
	public style: string;

	public monitorPolicyTag: AgentMonitorPolicyDto;
	public get hasMonitorPolicyTag(): boolean {
		return !!this.monitorPolicyTag;
	}

	constructor(monPolicy?: AgentMonitorPolicyDto, agent?: string, monPolicyState?: string) {
		if (!!monPolicy) {
			this.monitorPolicyGuid = monPolicy.MonitorPolicy.GUID;
			this.name = monPolicy.MonitorPolicy.Name;
			this.agent = agent;
			this.enabled = monPolicy.MonitorPolicy.Enabled;
			this.state = ((monPolicyState === "NoData") ? "No Data" : monPolicyState);
			this.style = "monitor-state-" + monPolicyState.toLowerCase();

			this.monitorPolicyTag = monPolicy;
		}
		else {
			this.monitorPolicyGuid = "";

			this.name = "";
			this.agent = "";
			this.enabled = false;
			this.state = "";
			this.style = "";

			this.monitorPolicyTag = null;
		}
	}
}


export class MonitoredDeviceListEntry {
	public deviceGuid: string;
	public agentGuid: string;
	public name: string;
	public ipAddress: string;
	public macAddress: string;
	public description: string;
	public snmpOid: string;
	public vendor: string;
	public state: string;
	public style: string;
	public monitorTypes: string[];

	public ipAddressTag: IpAddress;
	public get hasIpAddressTag(): boolean {
		return !!this.ipAddressTag;
	}

	public macAddressTag: MacAddress;
	public get hasMacAddressTag(): boolean {
		return !!this.macAddressTag;
	}

	public snmpOidTag: SnmpOid;
	public get hasSnmpOidTag(): boolean {
		return !!this.snmpOidTag;
	}

	constructor(entry: DisplayDeviceListEntryDto) {
		if (!!entry) {
			this.deviceGuid = entry.deviceGuid;
			this.agentGuid = entry.agentGuid;
			this.name = entry.name;
			this.ipAddress = entry.ipAddress;
			this.macAddress = entry.macAddress;
			this.description = entry.systemDescription;
			this.snmpOid = entry.systemOID;
			this.vendor = entry.vendor;
			this.state = ((entry.deviceState === "NoData") ? "No Data" : entry.deviceState);
			this.style = "monitor-state-" + entry.deviceState.toLowerCase();
			this.monitorTypes = entry.deviceMonitorTypes;

			this.ipAddressTag = IpAddress.Create(entry.ipAddress);
			this.macAddressTag = MacAddress.CreateFromString(entry.macAddress);
			this.snmpOidTag = SnmpOid.Create(entry.systemOID);
		}
		else {
			this.deviceGuid = "";
			this.agentGuid = "";
			this.name = "";
			this.ipAddress = "";
			this.macAddress = "";
			this.description = "";
			this.snmpOid = "";
			this.vendor = "";
			this.state = "";
			this.style = "";
			this.monitorTypes = [];

			this.ipAddressTag = null;
			this.macAddressTag = null;
			this.snmpOidTag = null;
		}
	}
}


@Component({
	selector: 'monitors',
	templateUrl: './monitors.component.html',
	styleUrls: ['./monitors.component.scss']
})
export class MonitorsComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public selected: boolean;

	public sections = [
		{
			header: 'Monitor Policies',
			categories: [
				{ title: 'Ping / Latency', value: 'monitors-ping' },
				/*{ title: 'Service (TCP) Port', value: 'monitors-port' },
				{ title: 'HTTP Monitors', value: 'monitors-http' },
				{ title: 'DNS Checks', value: 'monitors-dns' },
				{ title: 'CPU / Processor Load', value: 'monitors-cpu' },
				{ title: 'Disk / Storage', value: 'monitors-disk' },*/
				{ title: 'Custom SNMP Checks', value: 'monitors-snmp' },
				{ title: 'SNMP IF Utilization', value: 'monitors-snmpif' },
				{ title: 'Configs', value: 'monitors-config' },
				/*{ title: 'WMI Counters', value: 'monitors-wmi' },*/
				{ title: 'PRTG Monitors', value: 'monitors-prtg' },
			]
		},
		{
			header: 'Monitored Devices',
			categories: [
				{ title: 'All Devices', value: 'monitored-devices-all' },
			]
		},
		/*{
			header: 'Maintenance',
			categories: [
				{ title: 'Device Maintenance', value: 'maintenance-devices' },
			]
		},*/
	];

	public monCatToType: Object;

	private networkLoadedSub: Subscription;

	public selectedSection: string;
	public selectedCategory: string;

	private monitorsData: GetAgentMonitorPoliciesResultDto;
	public monitorsEntries: MonitorPolicyListEntry[];
	private selectedMonitorEntry: MonitorPolicyListEntry;

	public selectedPingPolicy: AgentMonitorPolicyDto;
	public pingEditorVisible: boolean;
	public pingStateVisible: boolean;

	public selectedSnmpIfPolicy: AgentMonitorPolicyDto;
	public snmpIfEditorVisible: boolean;
	public snmpIfStateVisible: boolean;

	public selectedConfigPolicy: AgentMonitorPolicyDto;
	public configEditorVisible: boolean;
	public configStateVisible: boolean;

	public selectedCustomSnmpPolicy: AgentMonitorPolicyDto;
	public customSnmpEditorVisible: boolean;
	public customSnmpStateVisible: boolean;

	public selectedPrtgPolicy: AgentMonitorPolicyDto;
	public prtgEditorVisible: boolean;

	private destroyed: boolean;
	private eventsInterval: number;
	private timerId: any;

	private monitoredDevicesData: DisplayDeviceListDto;
	public monitoredDevicesEntries: MonitoredDeviceListEntry[];
	public selectedMonitoredDeviceEntry: MonitoredDeviceListEntry;

	public monitoredDeviceStateVisible: boolean;

	public pingHistoryVisible: boolean;
	public snmpIfHistoryVisible: boolean;
	public configHistoryVisible: boolean;
	public customSnmpHistoryVisible: boolean;
	public prtgHistoryVisible: boolean;

	public selectedMonitorType: string;
	public selectedMonitorPolicyGuid: string;
	public selectedDeviceGuid: string;

	public displayDeleteMonitorPolicyConfirm: boolean;
	public deleteMonitorPolicyConfirmMessage: string;
	public displayDeleteMonitoredDeviceConfirm: boolean;
	public deleteMonitoredDeviceConfirmMessage: string;

	private deviceHistoryMenuItemsMap: { [deviceGuid: string]: MenuItem[] };


	constructor(private monService: MonitorService,
		private messageService: MessageService,
		private navService: NavigationService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private netFacadeService: NetFacadeService,
		private changeDetector: ChangeDetectorRef) {

		this.selected = false;

		this.monCatToType = {};
		this.monCatToType['monitors-ping'] = 'Ping';
		this.monCatToType['monitors-port'] = 'Port';
		this.monCatToType['monitors-http'] = 'HTTP';
		this.monCatToType['monitors-dns'] = 'DNS';
		this.monCatToType['monitors-cpu'] = 'CPU';
		this.monCatToType['monitors-disk'] = 'Disk';
		this.monCatToType['monitors-snmp'] = 'SNMP';
		this.monCatToType['monitors-snmpif'] = 'SNMP_Interface';
		this.monCatToType['monitors-wmi'] = 'WMI';
		this.monCatToType['monitors-config'] = 'Config';
		this.monCatToType['monitors-prtg'] = 'PRTG';

		this.selectedSection = "monitors";
		this.selectedCategory = "monitors-ping";

		this.monitorsData = new GetAgentMonitorPoliciesResultDto();
		this.monitorsEntries = [];
		this.selectedMonitorEntry = null;

		this.selectedPingPolicy = null;
		this.pingEditorVisible = false;
		this.pingStateVisible = false;

		this.selectedSnmpIfPolicy = null;
		this.snmpIfEditorVisible = false;
		this.snmpIfStateVisible = false;

		this.selectedConfigPolicy = null;
		this.configEditorVisible = false;
		this.configStateVisible = false;

		this.selectedCustomSnmpPolicy = null;
		this.customSnmpEditorVisible = false;
		this.customSnmpStateVisible = false;

		this.destroyed = false;
		this.eventsInterval = 0;
		this.timerId = undefined;

		this.monitoredDevicesData = { entries: [] };
		this.monitoredDevicesEntries = [];
		this.selectedMonitoredDeviceEntry = null;

		this.monitoredDeviceStateVisible = false;

		this.pingHistoryVisible = false;
		this.snmpIfEditorVisible = false;
		this.configEditorVisible = false;
		this.customSnmpHistoryVisible = false;
		this.prtgHistoryVisible = false;

		this.selectedMonitorType = "";
		this.selectedMonitorPolicyGuid = "";
		this.selectedDeviceGuid = "";

		this.displayDeleteMonitorPolicyConfirm = false;
		this.deleteMonitorPolicyConfirmMessage = "";
		this.displayDeleteMonitoredDeviceConfirm = false;
		this.deleteMonitoredDeviceConfirmMessage = "";

		this.deviceHistoryMenuItemsMap = {};
	}

	public ngOnInit(): void {

		// Only do this if a network is loaded
		if (this.navService.isNetworkLoaded) {
			this.retrieveData(true);
		}

		this.networkLoadedSub = this.discResultsService.onNetworkLoaded.subscribe(() => {
			this.retrieveData(true);
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (this.destroyed)
			return;

		if (changes["selected"]) {
			this.stopTimer();
			if (this.selected && this.navService.isNetworkLoaded) {
				this.retrieveData(true);
				this.startTimer();
			}
		}
	}

	public ngOnDestroy(): void {

		this.destroyed = true;

		this.stopTimer();

		if (this.networkLoadedSub) {
			this.networkLoadedSub.unsubscribe();
			this.networkLoadedSub = undefined;
		}
	}

	public get enableEditing(): boolean {
		return this.navService.location.hasAgentGuid;
	}

	public get enableHistory(): boolean {
		//return (this.selectedCategory !== "monitors-prtg");
		return true;
	}

	public get scrollHeight(): string {

		const HeaderHeight = 70;
		const RowHeight = 44;

		let desiredHeight = HeaderHeight;
		if (this.selectedSection === "monitors") {
			desiredHeight += (this.monitorsEntries.length * RowHeight);
		}
		else if (this.selectedSection == "monitored-devices") {
			desiredHeight += (this.monitoredDevicesEntries.length * RowHeight);
		}

		return `min(calc(100vh - 110px - 100px), ${desiredHeight}px)`;
	}

	private setEventsInterval(): void {
		this.eventsInterval = 0;

		let netViewGuid = this.navService.location.netViewGuid;
		let network: NetViewDto = this.netFacadeService.findNetwork(netViewGuid);
		if (network) {
			this.eventsInterval = network.EventsInterval;
		}
		else {
			this.messageService.displayErrorMessage("Could not set events interval");
		}
	}

	private get enableRetrieveData(): boolean {

		// TODO: add other editor dialogs to this check

		return (!this.pingEditorVisible && !this.snmpIfEditorVisible && !this.configEditorVisible &&
			!this.customSnmpEditorVisible);
	}

	private startTimer(): void {

		this.setEventsInterval();

		if (!this.timerId && this.selected && this.eventsInterval > 0) {
			let timeoutMillis = this.eventsInterval * 1000;
			this.timerId = setInterval(() => {
				if (this.enableRetrieveData) {
					this.retrieveData(false);
				}
			}, timeoutMillis);
		}
	}

	private stopTimer(): void {
		if (this.timerId) {
			clearInterval(this.timerId);
			this.timerId = undefined;
		}
	}

	private retrieveData(showBusy: boolean): void {
		this.retrieveAgentMonitorPolicies(showBusy);
		this.retrieveMonitoredDevices(showBusy);
	}

	private retrieveAgentMonitorPolicies(showBusy: boolean): Observable<GetAgentMonitorPoliciesResultDto> {

		let subject = new Subject<GetAgentMonitorPoliciesResultDto>();

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		this.monService.getAgentMonitorPolicies(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, undefined, true, true, showBusy).subscribe(
				(result: GetAgentMonitorPoliciesResultDto) => {
					this.monitorsData = result;
					this.setMonitorsEntries();

					subject.next(result);
				},
				(error) => {
					this.messageService.displayErrorMessage("Could not retrieve monitor policies");

					subject.error(error);
				});

		return subject.asObservable();
	}

	private retrieveMonitoredDevices(showBusy: boolean): Observable<DisplayDeviceListDto> {

		let subject = new Subject<DisplayDeviceListDto>();

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		this.monService.getMonitorDeviceList(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, showBusy).subscribe(
				(result: DisplayDeviceListDto) => {
					this.monitoredDevicesData = result;
					this.setMonitoredDevicesEntries();

					subject.next(result);
				},
				(error) => {
					this.messageService.displayErrorMessage("Could not retrieve monitored devices");

					subject.error(error);
				});

		return subject.asObservable();
	}

	public refreshMonitorPolicies(): void {
		this.retrieveAgentMonitorPolicies(true);
	}

	public refreshMonitoredDevices(): void {
		this.retrieveMonitoredDevices(true);
	}

	public onCategoryClicked(value: string): void {
		this.selectedCategory = value;

		let lastDashIdx = value.lastIndexOf('-');
		this.selectedSection = value.substr(0, lastDashIdx);

		this.setMonitorsEntries();
		this.setMonitoredDevicesEntries();
	}

	private setMonitorsEntries(): void {

		if (this.selectedSection !== 'monitors') {
			return;
		}

		this.setSelectedMonitorEntry(null);

		let targetMonType = this.monCatToType[this.selectedCategory];

		this.monitorsEntries = [];
		for (let i = 0; i < this.monitorsData.MonitorPolicies.Count; ++i) {
			let monPolicy: AgentMonitorPolicyDto = this.monitorsData.MonitorPolicies.Get(i);
			let monPolicyState: string = this.monitorsData.MonitorPolicyStates.Get(i);

			if (MonitorType[monPolicy.MonitorPolicy.MonitorType] === targetMonType) {
				let agent: AgentDto = this.netFacadeService.findAgent(monPolicy.AgentGuid);
				let agentName: string = (!!agent ? agent.Name : '');
				let newMonListEntry = new MonitorPolicyListEntry(monPolicy, agentName, monPolicyState);
				this.monitorsEntries.push(newMonListEntry);
			}
		}
	}

	private setMonitoredDevicesEntries(): void {

		if (this.selectedSection !== 'monitored-devices') {
			return;
		}

		this.setSelectedMonitoredDeviceEntry(null);

		this.deviceHistoryMenuItemsMap = {};
		this.monitoredDevicesEntries = [];
		for (let i = 0; i < this.monitoredDevicesData.entries.length; ++i) {
			let entry: DisplayDeviceListEntryDto = this.monitoredDevicesData.entries[i];

			let newMonDevListEntry = new MonitoredDeviceListEntry(entry);
			this.monitoredDevicesEntries.push(newMonDevListEntry);

			this.deviceHistoryMenuItemsMap[newMonDevListEntry.deviceGuid] =
				this.createDeviceHistoryMenuItems(newMonDevListEntry);
		}
	}

	public viewMonitorState(entry: MonitorPolicyListEntry): void {

		this.setSelectedMonitorEntry(entry);

		if (this.selectedCategory == "monitors-ping") {
			this.pingStateVisible = true;
		}
		else if (this.selectedCategory == "monitors-snmpif") {
			this.snmpIfStateVisible = true;
		}
		else if (this.selectedCategory == "monitors-config") {
			this.configStateVisible = true;
		}
		else if (this.selectedCategory == "monitors-snmp") {
			this.customSnmpStateVisible = true;
		}
	}

	public viewDeviceState(entry: MonitoredDeviceListEntry): void {
		this.setSelectedMonitoredDeviceEntry(entry);
		this.monitoredDeviceStateVisible = true;
	}

	public runPolicyAsap(entry: MonitorPolicyListEntry): void {

		this.setSelectedMonitorEntry(entry);

		let agentGuid: string = this.selectedMonitorEntry.monitorPolicyTag.AgentGuid;
		let agent: AgentDto = this.netFacadeService.findAgent(agentGuid);

		let policyGuid: string = this.selectedMonitorEntry.monitorPolicyGuid;

		this.netFacadeService.runMonitorAsap(agent, policyGuid).subscribe(
			(result: any) => {
				this.messageService.displayInfoMessage("Monitor Policy will run ASAP");
			},
			(error: any) => {
				this.messageService.displayErrorMessage("Operation Failed");
			});
	}

	public addMonitorPolicy(): void {
		if (this.enableEditing) {
			let monitorType = this.monCatToType[this.selectedCategory];

			let sessionGuid = this.identityService.sessionGuid;
			let netViewGuid = this.navService.location.netViewGuid;
			let agentGuid = this.navService.location.agentGuid;
			let schedDiscGuid = this.navService.location.schedDiscGuid;
			let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

			this.monService.createAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
				schedDiscRsltGuid, monitorType).subscribe(
					(result: UpdateResultDto) => {
						this.retrieveAgentMonitorPolicies(true).subscribe(
							(result_2: GetAgentMonitorPoliciesResultDto) => {
								//this.selectMonitorEntry(result.Guid);
								this.editMonitorPolicy(this.findMonitorEntryByGuid(result.Guid));
							});
					},
					(error) => {
						this.messageService.displayErrorMessage("Could not create monitor policy");
					});
		}
	}

	private findMonitorEntryByGuid(policyGuid: string): MonitorPolicyListEntry {
		return this.monitorsEntries.find((entry) => entry.monitorPolicyGuid === policyGuid);
	}

	public onSave(): void {
		//this.setMonitorsEntries();
		this.retrieveData(true);
	}

	public onCancel(): void {
		this.clearSelections();
	}

	private clearSelections(): void {
		this.selectedPingPolicy = null;
		this.selectedSnmpIfPolicy = null;
		this.selectedConfigPolicy = null;
		this.selectedCustomSnmpPolicy = null;
	}

	private setSelectedMonitorEntry(entry: MonitorPolicyListEntry): void {
		this.selectedMonitorEntry = entry;
		this.clearSelections();

		if (entry) {
			if (this.selectedCategory == "monitors-ping") {
				this.selectedPingPolicy = entry.monitorPolicyTag;
			}
			else if (this.selectedCategory == "monitors-snmpif") {
				this.selectedSnmpIfPolicy = entry.monitorPolicyTag;
			}
			else if (this.selectedCategory == "monitors-config") {
				this.selectedConfigPolicy = entry.monitorPolicyTag;
			}
			else if (this.selectedCategory == "monitors-snmp") {
				this.selectedCustomSnmpPolicy = entry.monitorPolicyTag;
			}
			else if (this.selectedCategory == "monitors-prtg") {
				this.selectedPrtgPolicy = entry.monitorPolicyTag;
			}
		}
	}

	private setSelectedMonitoredDeviceEntry(entry: MonitoredDeviceListEntry): void {
		this.selectedMonitoredDeviceEntry = entry;
	}

	public editMonitorPolicy(entry: MonitorPolicyListEntry): void {
		if (this.enableEditing) {
			this.setSelectedMonitorEntry(entry);

			if (this.selectedCategory == "monitors-ping") {
				this.pingEditorVisible = true;
			}
			else if (this.selectedCategory == "monitors-snmpif") {
				this.snmpIfEditorVisible = true;
			}
			else if (this.selectedCategory == "monitors-config") {
				this.configEditorVisible = true;
			}
			else if (this.selectedCategory == "monitors-snmp") {
				this.customSnmpEditorVisible = true;
			}
			else if (this.selectedCategory == "monitors-prtg") {
				this.prtgEditorVisible = true;
			}
		}
	}

	public confirmDeleteMonitorPolicy(entry: MonitorPolicyListEntry): void {
		if (this.enableEditing) {
			this.setSelectedMonitorEntry(entry);

			let policyName = entry.monitorPolicyTag.MonitorPolicy.Name;

			this.deleteMonitorPolicyConfirmMessage = `Are you sure you want to delete this monitor policy: ${policyName}?`;
			this.displayDeleteMonitorPolicyConfirm = true;
		}
	}

	public cancelDeleteMonitorPolicy(): void {
		this.deleteMonitorPolicyConfirmMessage = "";
		this.displayDeleteMonitorPolicyConfirm = false;
	}

	public deleteMonitorPolicy(): void {
		this.cancelDeleteMonitorPolicy();

		console.assert(this.enableEditing);
		if (this.enableEditing) {
			let policyToDelete = this.selectedMonitorEntry;
			if (policyToDelete) {
				let sessionGuid = this.identityService.sessionGuid;
				let netViewGuid = this.navService.location.netViewGuid;
				let agentGuid = this.navService.location.agentGuid;
				let schedDiscGuid = this.navService.location.schedDiscGuid;
				let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

				this.monService.deleteAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid,
					schedDiscGuid, schedDiscRsltGuid, policyToDelete.monitorPolicyGuid).subscribe(
						(result: boolean) => {
							this.retrieveData(true);
						},
						(error) => {
							this.messageService.displayErrorMessage("Could not delete monitor policy");
						});
			}
		}
	}

	public confirmDeleteMonitoredDevice(entry: MonitoredDeviceListEntry): void {
		if (this.enableEditing) {
			this.setSelectedMonitoredDeviceEntry(entry);

			let deviceName = this.selectedMonitoredDeviceEntry.name;

			this.deleteMonitoredDeviceConfirmMessage = `Are you sure you want to delete this monitored device: ${deviceName}?`;
			this.displayDeleteMonitoredDeviceConfirm = true;
		}
	}

	public cancelDeleteMonitoredDevice(): void {
		this.deleteMonitoredDeviceConfirmMessage = "";
		this.displayDeleteMonitoredDeviceConfirm = false;
	}

	public deleteMonitoredDevice(): void {
		this.cancelDeleteMonitoredDevice();

		console.assert(this.enableEditing);
		if (this.enableEditing) {
			let deviceToDelete = this.selectedMonitoredDeviceEntry;
			if (deviceToDelete) {
				let sessionGuid = this.identityService.sessionGuid;
				let netViewGuid = this.navService.location.netViewGuid;
				let agentGuid = this.navService.location.agentGuid;
				let schedDiscGuid = this.navService.location.schedDiscGuid;
				let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

				let deviceGuids: string[] = [deviceToDelete.deviceGuid];
				this.monService.removeDevicesFromAgentMonitorNetwork(sessionGuid, netViewGuid, agentGuid,
					schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
						(result: boolean) => {
							this.retrieveData(true);
						},
						(error) => {
							this.messageService.displayErrorMessage("Could not delete monitored device");
						});
			}
		}
	}

	public updateMonitoredDevice(entry: MonitoredDeviceListEntry): void {
		if (this.enableEditing) {
			this.setSelectedMonitoredDeviceEntry(entry);

			let deviceToUpdate = this.selectedMonitoredDeviceEntry;
			if (deviceToUpdate) {
				let sessionGuid = this.identityService.sessionGuid;
				let netViewGuid = this.navService.location.netViewGuid;
				let agentGuid = this.navService.location.agentGuid;
				let schedDiscGuid = this.navService.location.schedDiscGuid;
				let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

				let deviceGuids: string[] = [deviceToUpdate.deviceGuid];
				this.monService.updateDevicesInAgentMonitorNetwork(sessionGuid, netViewGuid, agentGuid,
					schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
						(result: boolean) => {
							this.retrieveData(true);
						},
						(error) => {
							this.messageService.displayErrorMessage("Could not update monitored device");
						});
			}
		}
	}

	public togglePolicyEnableState(entry: MonitorPolicyListEntry): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;

		// Get agent guid from entry.monitorPolicyTag so this will work at both network and agent levels
		//let agentGuid = this.navService.location.agentGuid;
		let agentGuid = entry.monitorPolicyTag.AgentGuid;

		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		this.monService.enableAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, entry.monitorPolicyGuid, !entry.enabled).subscribe(
				(result: UpdateResultDto) => {
					entry.enabled = !entry.enabled;
					entry.monitorPolicyTag.MonitorPolicy.Enabled = entry.enabled;
					this.messageService.displayInfoMessage(
						"Monitor policy successfully " + (entry.enabled ? "enabled" : "disabled"));
				},
				(error) => {
					this.messageService.displayErrorMessage("Could not update monitor policy");
				});
	}

	public clearPolicyHistoryAsap(entry: MonitorPolicyListEntry): void {

		this.setSelectedMonitorEntry(entry);

		// Get agent guid from entry.monitorPolicyTag so this will work at both network and agent levels
		let agentGuid = entry.monitorPolicyTag.AgentGuid;
		let agent = this.netFacadeService.findAgent(agentGuid);
		this.netFacadeService.clearMonitorPolicyHistoryAsap(agent, entry.monitorPolicyGuid).subscribe(
			(result: boolean) => {
				//this.retrieveData(true);
				this.messageService.displayInfoMessage("Monitor policy history will be cleared ASAP");
			},
			(error) => {
				this.messageService.displayErrorMessage("Could not clear monitor policy history");
			});
	}

	public clearDeviceHistoryAsap(entry: MonitoredDeviceListEntry): void {

		this.setSelectedMonitoredDeviceEntry(entry);

		// Get agent guid from entry.agentGuid so this will work at both network and agent levels
		let agentGuid = entry.agentGuid;
		let agent = this.netFacadeService.findAgent(agentGuid);
		this.netFacadeService.clearDeviceMonitorHistoryAsap(agent, entry.deviceGuid).subscribe(
			(result: boolean) => {
				//this.retrieveData(true);
				this.messageService.displayInfoMessage("Device monitor history will be cleared ASAP");
			},
			(error) => {
				this.messageService.displayErrorMessage("Could not clear device monitor history");
			});
	}

	public doCustomSort_Monitors(event): void {
		let comparer = function (a: MonitorPolicyListEntry, b: MonitorPolicyListEntry): number {
			let result = 0;

			switch (event.field) {
				//case "ipAddress":
				//	if (a.ipAddressTag && b.ipAddressTag) {
				//		result = a.ipAddressTag.CompareTo(b.ipAddressTag);
				//	}
				//	else if (a.ipAddressTag) {
				//		result = 1;
				//	}
				//	else if (b.ipAddressTag) {
				//		result = -1;
				//	}
				//	break;
				default:
					// Compare string fields
					result = a[event.field].toString().localeCompare(b[event.field].toString());
					break;
			}

			return result * event.order;
		}

		this.monitorsEntries.sort(comparer);
	}

	public doCustomSort_MonitoredDevices(event): void {
		let comparer = function (a: MonitoredDeviceListEntry, b: MonitoredDeviceListEntry): number {
			let result = 0;

			switch (event.field) {
				case "ipAddress":
					if (!!a.ipAddressTag && !!b.ipAddressTag) {
						result = a.ipAddressTag.CompareTo(b.ipAddressTag);
					}
					else if (!!a.ipAddressTag) {
						result = 1;
					}
					else if (!!b.ipAddressTag) {
						result = -1;
					}
					break;
				case "macAddress":
					if (!!a.macAddressTag && !!b.macAddressTag) {
						result = a.macAddressTag.CompareTo(b.macAddressTag);
					}
					else if (!!a.macAddressTag) {
						result = 1;
					}
					else if (!!b.macAddressTag) {
						result = -1;
					}
					break;
				case "snmpOid":
					if (!!a.snmpOidTag && !!b.snmpOidTag) {
						result = a.snmpOidTag.CompareTo(b.snmpOidTag);
					}
					else if (!!a.snmpOidTag) {
						result = 1;
					}
					else if (!!b.snmpOidTag) {
						result = -1;
					}
					break;
				default:
					// Compare string fields
					result = a[event.field].toString().localeCompare(b[event.field].toString());
					break;
			}

			return result * event.order;
		}

		this.monitoredDevicesEntries.sort(comparer);
	}

	public viewMonitorHistory(entry: MonitorPolicyListEntry): void {

		this.setSelectedMonitorEntry(entry);

		this.selectedMonitorPolicyGuid = this.selectedMonitorEntry.monitorPolicyGuid;
		this.selectedDeviceGuid = "";

		if (this.selectedCategory == "monitors-ping") {
			this.selectedMonitorType = "Ping";
			this.pingHistoryVisible = true;
		}
		else if (this.selectedCategory == "monitors-snmpif") {
			this.selectedMonitorType = "SNMP_Interface";
			this.snmpIfHistoryVisible = true;
		}
		else if (this.selectedCategory == "monitors-config") {
			this.selectedMonitorType = "Config";
			this.configHistoryVisible = true;
		}
		else if (this.selectedCategory == "monitors-snmp") {
			this.selectedMonitorType = "SNMP";
			this.customSnmpHistoryVisible = true;
		}
		else if (this.selectedCategory == "monitors-prtg") {
			this.selectedMonitorType = "PRTG";
			this.prtgHistoryVisible = true;
		}
	}

	public deviceHistoryMenuItems(entry: MonitoredDeviceListEntry): MenuItem[] {
		return this.deviceHistoryMenuItemsMap[entry.deviceGuid];
	}

	public createDeviceHistoryMenuItems(entry: MonitoredDeviceListEntry): MenuItem[] {

		let items: MenuItem[] = [];

		if (entry.monitorTypes.indexOf("Ping") >= 0) {
			items.push({
				icon: 'fa fa-history',
				label: 'Ping History',
				command: () => this.viewDevicePingHistory(entry),
			});
		}

		if (entry.monitorTypes.indexOf("SNMP_Interface") >= 0) {
			items.push({
				icon: 'fa fa-history',
				label: 'SNMP IF History',
				command: () => this.viewDeviceSnmpIfHistory(entry),
			});
		}

		if (entry.monitorTypes.indexOf("Config") >= 0) {
			items.push({
				icon: 'fa fa-history',
				label: 'Config History',
				command: () => this.viewDeviceConfigHistory(entry),
			});
		}

		if (entry.monitorTypes.indexOf("SNMP") >= 0) {
			items.push({
				icon: 'fa fa-history',
				label: 'SNMP History',
				command: () => this.viewDeviceCustomSnmpHistory(entry),
			});
		}

		if (entry.monitorTypes.indexOf("PRTG") >= 0) {
			items.push({
				icon: 'fa fa-history',
				label: 'PRTG History',
				command: () => this.viewDevicePrtgHistory(entry),
			});
		}


		return items;
	}

	public viewDevicePingHistory(entry: MonitoredDeviceListEntry): void {

		this.setSelectedMonitoredDeviceEntry(entry);

		this.selectedMonitorType = "Ping";
		this.selectedMonitorPolicyGuid = "";
		this.selectedDeviceGuid = this.selectedMonitoredDeviceEntry.deviceGuid;

		this.pingHistoryVisible = true;
	}

	public viewDeviceSnmpIfHistory(entry: MonitoredDeviceListEntry): void {

		this.setSelectedMonitoredDeviceEntry(entry);

		this.selectedMonitorType = "SNMP_Interface";
		this.selectedMonitorPolicyGuid = "";
		this.selectedDeviceGuid = this.selectedMonitoredDeviceEntry.deviceGuid;

		this.snmpIfHistoryVisible = true;
	}

	public viewDeviceConfigHistory(entry: MonitoredDeviceListEntry): void {

		this.setSelectedMonitoredDeviceEntry(entry);

		this.selectedMonitorType = "Config";
		this.selectedMonitorPolicyGuid = "";
		this.selectedDeviceGuid = this.selectedMonitoredDeviceEntry.deviceGuid;

		this.configHistoryVisible = true;
	}

	public viewDeviceCustomSnmpHistory(entry: MonitoredDeviceListEntry): void {

		this.setSelectedMonitoredDeviceEntry(entry);

		this.selectedMonitorType = "SNMP";
		this.selectedMonitorPolicyGuid = "";
		this.selectedDeviceGuid = this.selectedMonitoredDeviceEntry.deviceGuid;

		this.customSnmpHistoryVisible = true;
	}

	public viewDevicePrtgHistory(entry: MonitoredDeviceListEntry): void {

		this.setSelectedMonitoredDeviceEntry(entry);

		this.selectedMonitorType = "PRTG";
		this.selectedMonitorPolicyGuid = "";
		this.selectedDeviceGuid = this.selectedMonitoredDeviceEntry.deviceGuid;

		this.customSnmpHistoryVisible = true;
	}


}
